import React, {Component} from 'react';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Photography from './pages/Photography';
import Labs from './pages/Labs';
import Navbar from './pages/Navbar';
import Pro from './pages/Pro';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

class App extends Component{
render(){
return (

<Router>
    <div className="App">
      <div className="res">
        <p style={{fontSize: '4vw'}}>Still working on responsiveness, please use a desktop!</p>
      </div>
      <div className="theApp">
    <Navbar />
        <Switch>
        <Route exact path="/">
            <Home />
          </Route>
          <Route path="/Projects">
            <Projects />
          </Route>
          <Route path="/Photography">
            <Photography />
          </Route>
          <Route path="/Labs">
            <Labs />
          </Route>
        </Switch>
        <Route exact path="/Project/:project" component={Pro} />
    </div>
    </div>
</Router>

);
}
}

export default App;
